import { render, staticRenderFns } from "./PerfilTribunal.vue?vue&type=template&id=730767b4&scoped=true"
import script from "./PerfilTribunal.vue?vue&type=script&lang=js"
export * from "./PerfilTribunal.vue?vue&type=script&lang=js"
import style0 from "./PerfilTribunal.vue?vue&type=style&index=0&id=730767b4&prod&scoped=true&lang=css"
import style1 from "./PerfilTribunal.vue?vue&type=style&index=1&id=730767b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730767b4",
  null
  
)

export default component.exports